import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  fetchExercises,
  deleteExerciseAsync,
} from "../../redux/slices/exercisesSlice";
import Header from "../../components/Header";
import ExerciseTable from "./components/ExerciseTable";
import DeleteModal from "../../components/DeleteModal";
import AddButton from "../../components/AddButton";
import Loading from "../../components/Loading";
import Error from "../../components/Error";
import SuccessMessage from "../../components/SuccessMessage";
import ErrorMessage from "../../components/ErrorMessage";
import Pagination from "../../components/Pagination";
import { debounce } from "lodash";
import Select from "react-select";
import {
  WorkoutCategory,
  WorkoutProgram,
  TargetMuscle,
  searchExercises,
} from "../../services/exerciseService";

interface FilterOption {
  label: string;
  value: string;
}

const Exercises: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { exercises, loading, error, totalPages } = useSelector(
    (state: RootState) => state.exercises,
  ) as {
    exercises: any[];
    loading: boolean;
    error: { message: string } | null;
    currentPage: number;
    totalPages: number;
  };

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [exerciseToDelete, setExerciseToDelete] = useState<any>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [workoutCategories] = useState<WorkoutCategory[]>([]);
  const [workoutPrograms] = useState<WorkoutProgram[]>([]);
  const [targetMuscles] = useState<TargetMuscle[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [selectedNames, setSelectedNames] = useState<FilterOption[]>([]);
  const [nameOptions, setNameOptions] = useState<FilterOption[]>([]);
  const [isLoadingNames, setIsLoadingNames] = useState(false);

  const [selectedCategories, setSelectedCategories] = useState<FilterOption[]>(
    [],
  );
  const [categoryOptions, setCategoryOptions] = useState<FilterOption[]>([]);
  const [, setIsLoadingCategories] = useState(false);

  const [selectedPrograms, setSelectedPrograms] = useState<FilterOption[]>([]);
  const [programOptions, setProgramOptions] = useState<FilterOption[]>([]);
  const [isLoadingPrograms, setIsLoadingPrograms] = useState(false);

  const [selectedMuscles, setSelectedMuscles] = useState<FilterOption[]>([]);
  const [muscleOptions, setMuscleOptions] = useState<FilterOption[]>([]);
  const [isLoadingMuscles, setIsLoadingMuscles] = useState(false);

  useEffect(() => {
    const filters = {
      name: selectedNames.map((option) => option.value),
      categoryName: selectedCategories.map((option) => option.value),
      programName: selectedPrograms.map((option) => option.value),
      targetMuscleName: selectedMuscles.map((option) => option.value),
    };

    dispatch(
      fetchExercises({
        page: currentPage,
        limit: 10,
        ...filters,
      }),
    );
  }, [
    selectedNames,
    selectedCategories,
    selectedPrograms,
    selectedMuscles,
    currentPage,
    dispatch,
  ]);

  console.log(exercises);

  // useEffect(() => {
  //     const fetchData = async () => {
  //         const categories = await getWorkoutCategories();
  //         const programs = await getWorkoutPrograms();
  //         const muscles = await getTargetMuscles();
  //         setProgramOptions(programs.map(program => ({ label: program.title, value: program.id.toString() })));
  //         setCategoryOptions(categories.map(cat => ({ label: cat.title, value: cat.id.toString() })));
  //         setMuscleOptions(muscles.map(muscle => ({ label: muscle.name, value: muscle.name })));
  //     };
  //     fetchData();
  // }, []);

  // useEffect(() => {
  //     const fetchData = async () => {
  //         const [categories, programs, muscles] = await Promise.all([
  //             getWorkoutCategories(),
  //             getWorkoutPrograms(),
  //             getTargetMuscles()
  //         ]);
  //         setWorkoutCategories(categories);
  //         setWorkoutPrograms(programs);
  //         setTargetMuscles(muscles);
  //         setProgramOptions(programs.map(program => ({ label: program.title, value: program.id.toString() })));
  //         setCategoryOptions(categories.map(cat => ({ label: cat.title, value: cat.id.toString() })));
  //         setMuscleOptions(muscles.map(muscle => ({ label: muscle.name, value: muscle.name })));
  //     };
  //     fetchData();
  // }, []);

  const debouncedNameSearch = debounce(async (inputValue: string) => {
    setIsLoadingNames(true);
    try {
      const results = await searchExercises("name", inputValue);
      setNameOptions(results.map((name) => ({ label: name, value: name })));
    } catch (error) {
      console.error("Error searching names:", error);
    } finally {
      setIsLoadingNames(false);
    }
  }, 300);

  const debouncedCategorySearch = debounce(async (inputValue: string) => {
    setIsLoadingCategories(true);
    try {
      const results = await searchExercises("categoryName", inputValue);

      setCategoryOptions(results.map((name) => ({ label: name, value: name })));
    } catch (error) {
      console.error("Error searching names:", error);
    } finally {
      setIsLoadingNames(false);
    }
  }, 300);

  const debouncedProgramSearch = debounce(async (inputValue: string) => {
    setIsLoadingPrograms(true);
    try {
      const results = await searchExercises("programName", inputValue);

      setProgramOptions(
        results.map((name) => ({
          label: name,
          value: name,
        })),
      );
    } catch (error) {
      console.error("Error searching programs:", error);
    } finally {
      setIsLoadingPrograms(false);
    }
  }, 300);

  const debouncedMuscleSearch = debounce(async (inputValue: string) => {
    setIsLoadingMuscles(true);
    try {
      const results = await searchExercises("targetMuscleName", inputValue);

      setMuscleOptions(
        results.map((name) => ({
          label: name,
          value: name,
        })),
      );
    } catch (error) {
      console.error("Error searching programs:", error);
    } finally {
      setIsLoadingMuscles(false);
    }
  }, 300);

  // useEffect(() => {
  //     const fetchData = async () => {
  //         const [categories, programs, muscles] = await Promise.all([
  //             getWorkoutCategories(),
  //             getWorkoutPrograms(),
  //             getTargetMuscles()
  //         ]);
  //         setWorkoutCategories(categories);
  //         setWorkoutPrograms(programs);
  //         setTargetMuscles(muscles);
  //     };
  //     fetchData();
  // }, []);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const openDetailsPage = (exercise: any) => {
    navigate("/exercise-details", { state: { exercise } });
  };

  const openEditPage = (exercise: any) => {
    navigate("/edit-exercise", { state: { exercise } });
  };

  const openDeleteModal = (exercise: any) => {
    setExerciseToDelete(exercise);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setExerciseToDelete(null);
  };

  const handleDeleteConfirm = async () => {
    try {
      if (exerciseToDelete) {
        await dispatch(deleteExerciseAsync(exerciseToDelete.id)).unwrap();
        setSuccessMessage("Exercise deleted successfully!");
        closeDeleteModal();
        dispatch(fetchExercises({ page: currentPage, limit: 10 }));
      }
    } catch {
      setErrorMessage("Failed to delete exercise. Please try again.");
      closeDeleteModal();
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <Header title="Exercises" />
      <div className="mb-4 grid grid-cols-1 md:grid-cols-3 gap-4">
        <Select
          isMulti
          options={nameOptions}
          value={selectedNames}
          onChange={(selected) => setSelectedNames(selected as FilterOption[])}
          onInputChange={(input) => {
            if (typeof input === "string") {
              debouncedNameSearch(input);
            }
          }}
          placeholder="Filter by Name"
          className="basic-multi-select"
          classNamePrefix="select"
          isLoading={isLoadingNames}
          isClearable
        />

        <Select
          isMulti
          options={categoryOptions}
          value={selectedCategories}
          onChange={(selected) => {
            console.log("Selected Categories:", selected);
            setSelectedCategories(selected as FilterOption[]);
          }}
          onInputChange={(input) => {
            if (typeof input === "string") {
              debouncedCategorySearch(input);
            }
          }}
          placeholder="Filter by Category"
          className="basic-multi-select"
          classNamePrefix="select"
          isClearable
        />
        <Select
          isMulti
          options={programOptions}
          value={selectedPrograms}
          onChange={(selected) =>
            setSelectedPrograms(selected as FilterOption[])
          }
          onInputChange={(input) => {
            if (typeof input === "string") {
              debouncedProgramSearch(input);
            }
          }}
          placeholder="Filter by Program"
          isClearable
          isLoading={isLoadingPrograms}
        />
        <Select
          isMulti
          options={muscleOptions}
          value={selectedMuscles}
          onChange={(selected) =>
            setSelectedMuscles(selected as FilterOption[])
          }
          onInputChange={(input) => {
            if (typeof input === "string") {
              debouncedMuscleSearch(input);
            }
          }}
          placeholder="Filter by Target Muscle"
          isLoading={isLoadingMuscles}
          isClearable
        />
      </div>
      {loading ? (
        <Loading message="Fetching exercises..." />
      ) : error ? (
        <Error
          message={"Failed to fetch exercises"}
          onRetry={() =>
            dispatch(fetchExercises({ page: currentPage, limit: 10 }))
          }
        />
      ) : (
        <>
          <div className="mt-4 flex justify-end">
            <AddButton
              onClick={() => navigate("/add-exercise")}
              text="Add Exercise"
            />
          </div>
          <div className="rounded-lg overflow-x-auto">
            {successMessage && (
              <SuccessMessage
                message={successMessage}
                onClose={() => setSuccessMessage(null)}
              />
            )}
            {errorMessage && (
              <ErrorMessage
                message={errorMessage}
                onClose={() => setErrorMessage(null)}
              />
            )}
            <ExerciseTable
              exercises={exercises}
              workoutCategories={workoutCategories}
              workoutPrograms={workoutPrograms}
              targetMuscles={targetMuscles}
              onEdit={openEditPage}
              onDelete={openDeleteModal}
              onMore={openDetailsPage}
            />
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </>
      )}
      {isDeleteModalOpen && (
        <DeleteModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDeleteConfirm}
          itemName={exerciseToDelete?.name}
          itemType="exercise"
        />
      )}
    </div>
  );
};

export default Exercises;
